export function randomBool() {
  return Math.random() < 0.5
}
